module.exports = __webpack_public_path__ + "static/dot_pattern-3ca3d2f1f749d43e2d5c0061e7d1a53f.svg";